import type { Maybe } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { CourseDigital } from '@chancenwerk/shared/courses/CourseDigital.js';
import { ChromiumDialog } from '@chancenwerk/client/design/components/cr-dialog.js';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('board-dialog-choose-digital-course')
export class BoardDialogChooseDigitalCourse extends ChromiumDialog<CourseDigital> {
  @state() private readonly _courses = new RXController(
    this,
    CourseDigital.subscribeAll<CourseDigital>()({
      _id: 1,
      subject: 1,
      jahrgangsstufe: 1,
      weekday: 1,
      startTime: 1,
      endTime: 1,
      linkedKPFIDs: 1,
    }),
  );

  @state() private readonly _selectedCourse = new RXController<CourseDigital | null>(this, null);

  @property() public kpfId = '';

  static override get element_name() {
    return 'board-dialog-choose-digital-course';
  }

  override heading = 'digitalen Kurs auswählen';

  override content() {
    return html`
      <cr-flex space="md">
        <cr-dropdown-selection
          clearable
          .value=${this._selectedCourse.value}
          ?flex=${!this._selectedCourse.value}
          icon="search"
          placeholder="Kurs"
          .selectables=${this._courses.value?.filter(k => !k.linkedKPFIDs?.some(id => id === this.kpfId))}
          .renderString=${(entry: Maybe<CourseDigital>) => {
            if (!entry) return `Kurs auswählen`;
            return `${entry.weekday ?? ''}
            ${
              entry.startTime && entry.endTime
                ? `${entry.startTime.toFormat('HH:mm')} - ${entry.endTime.toFormat('HH:mm')}`
                : ''
            } ${entry.subject ?? ''} ${entry.jahrgangsstufe ? `Stufe ${entry.jahrgangsstufe}` : ''} `;
          }}
          .renderItem=${(entry: Maybe<CourseDigital>) => {
            if (!entry) return html`<cr-text>Kurs auswählen</cr-text>`;
            return html`<cr-flex space="sm" padding="sm">
              <cr-text>
                ${entry.weekday ?? ''}
                ${entry.startTime && entry.endTime
                  ? `${entry.startTime.toFormat('HH:mm')} - ${entry.endTime.toFormat('HH:mm')}`
                  : ''}
              </cr-text>
              <cr-text> ${entry.subject ?? ''} ${entry.jahrgangsstufe ? `Stufe ${entry.jahrgangsstufe}` : ''} </cr-text>
            </cr-flex>`;
          }}
          @value-picked=${(e: CustomEvent<{ value: CourseDigital }>) => {
            this._selectedCourse.next(e.detail.value);
          }}
        ></cr-dropdown-selection>

        ${this._selectedCourse.value
          ? html`
              <cr-button
                icon="add"
                @click=${async () => {
                  if (!this._selectedCourse.value) {
                    return;
                  }

                  if (!this.kpfId) {
                    throw new Error('KPF ID fehlt.');
                  }

                  this._selectedCourse.value.linkedKPFIDs = (this._selectedCourse.value.linkedKPFIDs ?? []).concat([
                    this.kpfId,
                  ]);
                  await this._selectedCourse.value.save();
                  await this.close(this._selectedCourse.value);
                }}
              ></cr-button>
            `
          : nothing}
      </cr-flex>
    `;
  }
}
